import { Card } from "@remo-co/ui-core/src/components/Card";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useStyles } from "./MenuItem.styles";
import EmptyEventIcon from "../../assets/empty-event.svg";

const PreviewEmptyMenuItem = () => {
  const { t } = useI18n(["eventDirectory"]);
  const styles = useStyles();

  return (
    <Card
      size="xs"
      flex
      fullWidth
      className={styles.cardItems}
      justifyContent="flex-start"
    >
      <img
        src={EmptyEventIcon}
        alt={t("eventDirectory:no.event.selected")}
        className={styles.eventImage}
      />
      <Typography variant="h5" color="textPrimary">
        {t("eventDirectory:no.event.selected")}
      </Typography>
    </Card>
  );
};

export default PreviewEmptyMenuItem;
